import { customerService } from '@/services';

export const customerModule = {
  namespaced: true,
  state: () => ({
    list:{
      data: null,
      error: null,
    },
    client:{
      data: null,
      error: null,
    },
    newClient:{
      data: null,
      status: null,
    },
    updateClient:{
      data: null,
      status: null,
    },
  }),
  mutations: {
    load(state, request) {
      let pagination=null;
      let filters=null;
      if (request){
        pagination= request.pagination;
        filters= request.filters;}
      customerService.getCustomers(pagination,filters)
      .then((res) => {
        state.list.data = res
      })
      .catch((error) => {
        state.list.data = null
        state.list.error = error
      });    
    },
    getById(state, id) {
      customerService.getClientById(id)
        .then((res) => {
          state.client.data = res
        })
        .catch((error) => {
          state.client.data = null
          state.client.error = error
        });      
    },
    createClient(state, body) {
      customerService.newClient(body)
      .then((res) => {
        state.newClient.data = res
        state.newClient.status= {
          created: true
        }
      })
      .catch((error) => {
        state.newClient.data = null
        state.newClient.status ={
          error: error,
        }
      });    
    },
    updateClient(state, request) {
      customerService.updateClient(request.body, request.id)
      .then((res) => {
        state.updateClient.data = res
        state.updateClient.status = {updated: true}
      })
      .catch((error) => {
        state.updateClient.data = null
        state.updateClient.status = { error: error}
      });    
    },
    
  }
}